import { render } from "./search-box.component.vue?vue&type=template&id=52b1c90a"
import script from "./search-box.component.vue?vue&type=script&lang=js"
export * from "./search-box.component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__